import {
  addFlash
} from '../reducers/flashes'

export const addFlashes = ({ dispatch, getState }) => {
  return (next) => (action) => {
    if (action.type) {
      addFlash(action.type)(dispatch)
    }
    return next(action)
  }
}
